import { useMarketStore } from '@/store/use-markets-store';
import { bigIntToNum, formatBigInt } from '@/utils/value-format';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

type Props = {
  symbol: string;
};

export default function MidPrice({ symbol }: Props) {
  const { midPrice, priceDecimals } = useStore(
    useMarketStore(symbol),
    useShallow((state) => ({
      midPrice: state.marketData.midPrice,
      priceDecimals: state.marketSpec.priceDecimals,
    })),
  );
  return formatBigInt(midPrice, priceDecimals, {
    style: 'currency',
    digits: Number(priceDecimals),
  });
}

export const midPriceAccessorFn = (symbol: string) => {
  const {
    marketData: { midPrice },
    marketSpec: { priceDecimals },
  } = useMarketStore(symbol).getState();
  return bigIntToNum(midPrice, priceDecimals);
};
